import axios from 'axios';
import environment from 'environment';

import { JsonResponse } from 'core/models/response';
import { CommercialEntitiesListResponse, CommercialEntity } from '../models/commercialEntities';

export const onGetCommercialEntities = (page: number = 1, search?: string) => {
	return axios.get<JsonResponse<CommercialEntitiesListResponse>>(`${environment.BASE_API_ENDPOINT}/admin/investment-entities`, {
		params: {
			page,
			search,
		},
	});
};

export const onGetCommercialEntityById = (commercialEntityId: string) => {
	return axios.get<JsonResponse<CommercialEntity>>(`${environment.BASE_API_ENDPOINT}/admin/investment-entities/${commercialEntityId}`);
};

export const onDeleteCommercialEntity = (commercialEntityId: string) => {
	return axios.delete<JsonResponse<CommercialEntity>>(`${environment.BASE_API_ENDPOINT}/admin/investment-entities/${commercialEntityId}`);
};

export const onRejectCommercialEntity = (commercialEntityId: string, rejection_reason: string) => {
	return axios.put<JsonResponse<CommercialEntity>>(
		`${environment.BASE_API_ENDPOINT}/admin/investment-entities/reject/${commercialEntityId}`,
		{ rejection_reason },
	);
};

export const onApproveCommercialEntity = (commercialEntityId: string) => {
	return axios.put<JsonResponse<CommercialEntity>>(
		`${environment.BASE_API_ENDPOINT}/admin/investment-entities/approve/${commercialEntityId}`,
	);
};

export const onUnlinkCommercialEntity = (commercialEntityId: string) => {
	return axios.put(`${environment.BASE_API_ENDPOINT}/admin/investment-entities/unlink/${commercialEntityId}`);
};

export const onUpdateCommercialEntity = (commercialEntityId: string, payload: any) => {
	return axios.put(`${environment.BASE_API_ENDPOINT}/admin/investment-entities/${commercialEntityId}`, { ...payload });
};
